// Forum registration form: client-side validation, JSON submit, then the
// Success state (drawn in Figma) or field / general errors (not drawn).
//
// Endpoint contract (Frontend\ForumRegistrationController@store):
// POST form fields → 2xx = registered; 422 { errors: { field: [message] } } = invalid.
// All copy comes from the markup (data-msg-* on the form); the JS never logs or keeps the submitted personal data.
$(function () {
    const $root = $('[data-forum-registration]');

    if (!$root.length) {
        return;
    }

    const form = $root.find('[data-forum-registration-form]')[0];
    const $submit = $root.find('[data-forum-registration-submit]');
    const $generalError = $root.find('[data-forum-registration-error]');
    const $success = $root.find('[data-forum-registration-success]');
    const messages = form.dataset;
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Phone mask "+373 XX XXX XXX": digits only, the +373 prefix is fixed.
    const PHONE_PREFIX = '+373 ';
    const PHONE_DIGITS = 8;

    const phoneDigits = (value) => {
        let digits = value.replace(/\D/g, '');

        if (value.startsWith('+373') || (digits.startsWith('373') && digits.length > PHONE_DIGITS)) {
            digits = digits.slice(3);
        } else if (digits.startsWith('0')) {
            digits = digits.slice(1); // local format 0XX XXX XXX
        }

        return digits.slice(0, PHONE_DIGITS);
    };

    const formatPhone = (digits) => {
        const parts = [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 8)].filter(Boolean);

        return PHONE_PREFIX + parts.join(' ');
    };

    // Caret goes after the same number of local digits it was after before formatting.
    const caretAfterDigits = (value, count) => {
        let seen = 0;

        for (let i = PHONE_PREFIX.length; i < value.length; i++) {
            if (seen === count) {
                return i;
            }
            if (/\d/.test(value[i])) {
                seen++;
            }
        }

        return value.length;
    };

    const isPhoneComplete = (input) => phoneDigits(input.value).length === PHONE_DIGITS;

    $(form).find('[data-phone-mask]').each(function () {
        const input = this;
        let previous = input.value;

        input.addEventListener('focus', () => {
            if (!input.value) {
                input.value = previous = PHONE_PREFIX;
            }
        });

        input.addEventListener('blur', () => {
            if (!phoneDigits(input.value)) {
                input.value = previous = '';
            }
        });

        input.addEventListener('input', (event) => {
            const caret = input.selectionStart ?? input.value.length;
            const beforeCaret = input.value.slice(0, caret);
            let digits = phoneDigits(input.value);
            let digitsBeforeCaret = caret < PHONE_PREFIX.length ? 0 : phoneDigits(beforeCaret).length;

            // Backspace over a space only removes the space — drop the digit before it instead.
            if (event.inputType === 'deleteContentBackward' && digits === phoneDigits(previous) && digitsBeforeCaret > 0) {
                digits = digits.slice(0, digitsBeforeCaret - 1) + digits.slice(digitsBeforeCaret);
                digitsBeforeCaret--;
            }

            input.value = previous = formatPhone(digits);
            const position = caretAfterDigits(input.value, digitsBeforeCaret);
            input.setSelectionRange(position, position);
        });
    });

    const fieldOf = (input) => $(input).closest('[data-form-field]');

    const showGeneralError = (message) => {
        $generalError.text(message).addClass('is-visible');
    };

    const setError = (input, message) => {
        const $field = fieldOf(input);

        $field.toggleClass('is-invalid', Boolean(message));
        $field.find('[data-form-field-error]').text(message || '');
        input.setAttribute('aria-invalid', message ? 'true' : 'false');
    };

    const validate = (input) => {
        let message = '';

        if (input.type === 'checkbox') {
            message = input.required && !input.checked ? messages.msgConsent : '';
        } else {
            const value = input.value.trim();

            if (input.required && !value) {
                message = messages.msgRequired;
            } else if (input.type === 'email' && value && !EMAIL_PATTERN.test(value)) {
                message = messages.msgEmail;
            } else if (input.hasAttribute('data-phone-mask') && phoneDigits(value) && !isPhoneComplete(input)) {
                message = messages.msgPhone;
            }
        }

        setError(input, message);

        return !message;
    };

    const inputs = () => Array.from(form.querySelectorAll('input[name]'));

    // Re-validate a field the user is fixing, once it has been flagged.
    $(form).on('input change', 'input[name]', function () {
        if (fieldOf(this).hasClass('is-invalid')) {
            validate(this);
        }
    });

    $(form).on('submit', async function (event) {
        event.preventDefault();
        $generalError.removeClass('is-visible');

        const invalid = inputs().filter((input) => !validate(input));

        if (invalid.length) {
            invalid[0].focus();
            return;
        }

        $submit.addClass('is-loading').prop('disabled', true);

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
                },
                body: new FormData(form),
            });

            if (response.ok) {
                form.reset();
                form.hidden = true;
                $success.prop('hidden', false).trigger('focus');
                return;
            }

            const data = response.status === 422 ? await response.json().catch(() => ({})) : {};
            const errors = data.errors || {};
            let firstInvalid = null;

            Object.keys(errors).forEach((name) => {
                const input = form.elements.namedItem(name);

                if (input instanceof HTMLInputElement) {
                    setError(input, [].concat(errors[name])[0]);
                    firstInvalid = firstInvalid || input;
                }
            });

            // 422 — the data needs fixing; anything else (500, 419…) — the server failed.
            showGeneralError(response.status === 422 ? messages.msgGeneral : messages.msgServer);
            firstInvalid?.focus();
        } catch {
            showGeneralError(messages.msgServer);
        } finally {
            $submit.removeClass('is-loading').prop('disabled', false);
        }
    });
});
